import React from "react";
import { BaseComponent } from "../core/BaseComponent";
export class AttentionDaysTableHeader extends BaseComponent {
    render() {
        return <thead><tr>
            <td className="dagcellHeader">{this.translate("attentiondays.description")}</td>
            <td className="dagcellHeader">{this.translate("attentiondays.kind")}</td>
            <td className="dagcellHeader">{this.translate("attentiondays.date-from")}</td>
            <td className="dagcellHeader">{this.translate("attentiondays.date-to")}</td>
            <td className="dagcellHeader">&nbsp;</td>
        </tr>
        </thead>;
    }
}
